/* This component is used for the order summary displayed on the basket page and mini basket */

import Link from "next/link";

import styles from "../Basket.module.scss";

import CheckoutButton from "@/components/common/CheckoutButton";
import { formatPrice } from "@/helpers/pdpHelpers/priceHelpers";
import YotpoTierPoints from "@/components/YotpoTierPoints";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function OrderSummary({
  summary,
  country,
  checkoutUrl,
  isFullBasket,
  checkoutText,
  isOnlyOOS,
}) {
  const deliveryFee = country === 1 ? 0 : 30;
  let subtotal, estimatedTotal, total;
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  if (summary.lineItemsSubtotalPrice && summary.subtotalPriceV2) {
    subtotal = formatPrice(summary.lineItemsSubtotalPrice.amount);
    total = parseInt(summary.subtotalPriceV2.amount) + deliveryFee;
    estimatedTotal = formatPrice(total.toString());
  }
  

  return (
    <>
      {summary && (
        <div className={`order_summary_section ${styles.order_summary} ${isPWA?styles.order_summary_pwa:""} `}>
          {isFullBasket && (
            <div className="normal-xs normal-sm large-md ordersummery">
              Order Summary
            </div>
          )}
          <div className={`row ${styles.total_wrapper}`}>
            <div className="grid-xs-8">
              {/* {subtotal && (
                <div className={styles.space}>
                  <span
                    id="#BasketSubtotalText"
                    className="small-xs small-sm small-md"
                  >
                    Subtotal
                  </span>
                </div>
              )} */}
              {isFullBasket && <div className={styles.space}>
                <span
                  id="#BasketDelivery"
                  className="small-xs small-sm small-md"
                >
                  {country == 1
                    ? "Standard delivery"
                    : "International Delivery"}
                </span>
              </div>}
              {estimatedTotal && (
                <div className={styles.space}>
                  <span
                    id="#BasketEstTotal"
                    className="small-xs normal-sm normal-md bold"
                  >
                    Estimated total
                  </span>

                  <span className="d-block xx-small">Final taxes calculated at checkout</span>
                </div>
              )}
            </div>

            <div className="grid-xs-4 text-end">
              {/* {subtotal && (
                <div className={styles.space}>
                  <span
                    id="#BasketSubtotal"
                    className="small-xs small-sm small-md"
                  >
                    {subtotal}
                  </span>
                </div>
              )} */}
              {isFullBasket && <div className={styles.space}>
                <span
                  id="#BasketFee"
                  className="small-xs small-sm small-md"
                >
                  {deliveryFee > 0 ? `$${deliveryFee}` : "Free"}
                </span>
              </div>}
              {estimatedTotal && (
                <div id="#BasketestAmount" className={styles.space}>
                  <span className="small-xs normal-sm normal-md bold">
                    {estimatedTotal}
                  </span>
                </div>
              )}
            </div>
          </div>
        
          {isFullBasket && <YotpoTierPoints price={total} isBorder={true} compClass={"your-bag-tier-wrapper"} isBag={true}/>}
          
          {checkoutUrl && (
            <div className={`text-center ${styles.cta_wrapper}`}>
              <CheckoutButton
                id="#BasketCheckout"
                href={checkoutUrl}
                checkoutText={checkoutText}
                className={isFullBasket?"small-sm":""}
                isOnlyOOS={isOnlyOOS}
                showPaymentIcons={false}
              />
              {country != 1 && (
                <div
                  id="#BasketTaxesDuties"
                  className={`xx-small-xs xx-small-sm x-small-md ${styles.duties}`}
                >
                  Taxes and duties are calculated at checkout
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
